import styled from 'styled-components';
import { ButtonText } from '../../../typography';
import { getColor, getSizeBy } from '../../../../../src/styled/utils';
import { BorderBottom } from '../../../../../src/styled/shared-styles';
export const SearchBlockWrap = styled.div `
  display: flex;
  align-items: center;
  min-height: ${getSizeBy(15)};
  padding: 0 ${getSizeBy(4)} 0 0;
  column-gap: ${getSizeBy(3)};
  background: ${getColor('surface')};
  ${BorderBottom}
`;
export const TextButtonStyled = styled(ButtonText) `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
